import { render, staticRenderFns } from "./CardOfficial.vue?vue&type=template&id=e440522e&scoped=true"
import script from "./CardOfficial.vue?vue&type=script&lang=js"
export * from "./CardOfficial.vue?vue&type=script&lang=js"
import style0 from "./CardOfficial.vue?vue&type=style&index=0&id=e440522e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e440522e",
  null
  
)

export default component.exports